import React from 'react';
import { Modal, Box, Stack } from "@mui/material";
import { useForm } from 'react-hook-form';
import InputLabel from '../../components/form/InputLabel';
import Button from '../../components/Button';
import validators from "../../utils/validators";
import { useDispatch, useSelector } from "react-redux";
import {
  editarSituacaoRequest,
} from "../../reducers/oportunidade.reducer";
import Autocomplete from "../../components/form/Autocomplete";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const StatusModal = ({ open, handleClose, tipoSituacao, idOportunidade }) => {
  const rules = {
    tipoSituacao: validators.string({ required: true }),
  };
  const initialValues = {
    tipoSituacao: tipoSituacao,
  };
  const dispatch = useDispatch();
  const tipoSituacaoOportunidade = useSelector((state) => state.dominios.tipoSituacaoOportunidade)

  const formProps = {
    ...useForm(),
    rules,
    initialValues
  };

  const onSubmit = async (data) => {
    const body = {
      idOportunidade: idOportunidade,
      tipoSituacao: data.tipoSituacao.codigo
    }
    dispatch(editarSituacaoRequest(body))
    handleClose()
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <form onSubmit={formProps.handleSubmit(onSubmit)}>
          <Box sx={{ mt: 2 }}>
            <Stack spacing={1}>
              <InputLabel htmlFor="tipoSituacao">Status</InputLabel>
              <Autocomplete
                id="tipoSituacao"
                name="tipoSituacao"
                placeholder="Escolha o Status"
                fullWidth
                labelField={"nome"}
                idField={"codigo"}
                domain={tipoSituacaoOportunidade}
                formProps={formProps}
              />
            </Stack>
          </Box>
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={handleClose} sx={{ mr: 1 }}>
              Cancelar
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Confirmar
            </Button>
          </Box>
        </form>
      </Box>
    </Modal>
  );
};

export default StatusModal;
